$(document).ready(function() {
    let navbarToggler = document.querySelector('nav.navbar .navbar-toggler');
    navbarToggler.classList.add('d-flex');
    navbarToggler.classList.remove('locked');
});

import { SvgInjector } from './modules/svgInjector';
import { Parallax } from './modules/parallax';
import { ImagePopUp } from './modules/imagePopUp';
import { MiniGallery } from './modules/miniGallery';
import { Cookies } from './modules/cookies';
import { ScrollTo } from './modules/scrollTo';
import { GoogleMaps } from './modules/googleMaps';
import { Video } from './modules/video';
import { Validator } from './modules/validator';
import { SidePanel } from './modules/sidePanel';
import {SwiperSlider}     from './modules/swiperSlider';
import { Nav } from './modules/nav';
import { ThemesList } from './modules/themesList';
import { ThemeModal } from './modules/themeModal';
import { ThemesListAnimations } from './modules/themesListAnimations';
import { Accordion } from './modules/accordion';
import { Visible } from './modules/visible';
import { Disclaimer } from './modules/disclaimer';
import { AuthModal } from './modules/authModal';
import { UserProfile } from './modules/userProfile';
import { ApiPagination } from './modules/apiPagination';
import { TeamPopup } from './modules/teamPopup';
import { InvestmentProducts } from './modules/investmentProducts';
import { CybersecurityGraph } from './modules/cybersecurityGraph';
import { Claims } from './modules/claims';
import { ClaimModal } from './modules/claimModal';
import { ProductReports } from './modules/productReports';
import { Contracts } from './modules/contracts';
window.Swiper = require("../../../../node_modules/swiper/dist/js/swiper");

import './modules/searchHandler';

var svgInjector = new SvgInjector();
var parallax = new Parallax();
var imagePopUp = new ImagePopUp();
var miniGallery = new MiniGallery();
var cookies = new Cookies();
var scrollTo = new ScrollTo();
var googleMaps = new GoogleMaps();
var video = new Video();
var validator = new Validator();
var sidePanel = new SidePanel();
var swiper = new SwiperSlider();
var nav = new Nav();
var themeModal = new ThemeModal();
var themesList = new ThemesList();
var themesListAnimations = new ThemesListAnimations();
var accordion = new Accordion();
var visible = new Visible();
var disclaimer = new Disclaimer();
var authModal = new AuthModal();
var userProfile = new UserProfile();
var apiPagination = new ApiPagination();
var teamPopup = new TeamPopup();
var investmentProducts = new InvestmentProducts();
var cybersecurityGraph = new CybersecurityGraph();
var claims = new Claims();
var claimModal = new ClaimModal();
var productReports = new ProductReports();
var contracts = new Contracts();

class Main {
    constructor(node_env) {
        this.node_env = node_env;
        this.sections = $('.cms-section');
    }
    bootstrap(callback) {
        var $sections = $(this.sections);
        this.modules($sections);
        this.responsiveModules($sections);
        callback();
    }

    modules($sections) {
        parallax.init($sections);
        svgInjector.init();
        imagePopUp.init();
        miniGallery.init();
        cookies.init();
        scrollTo.init();
        googleMaps.init();
        video.init();
        validator.init();
        sidePanel.init();
        swiper.init();
        nav.init();
        // themesHP.init();
        themeModal.init();
        themesList.init();
        themesListAnimations.init();
        // articleRwd.init();
        accordion.init();
        visible.init();
        // branchFilter.init();
        // organizationalChart.init();
        disclaimer.init();
        authModal.init();
        userProfile.init();
        apiPagination.init();
        teamPopup.init();
        investmentProducts.init();
        cybersecurityGraph.init();
        claims.init();
        claimModal.init();
        productReports.init();
        contracts.init();

    }

    responsiveModules($sections) {
        $(window).resize(function() {
            parallax.init($sections);
            miniGallery.init();
        });
    }
}

$(window).load(function() {
    var main = new Main('development');
    main.bootstrap(function() {

    });
    if(document.body.classList.contains('article') && !document.body.classList.contains('team')){
        $("body").prognroll({
            height: '4px',
            color: '#ff692c'
        });
        $("#share").jsSocials({
            shares: ["email", "twitter", "facebook", "linkedin", "pinterest", "whatsapp"]
        });
    }

    if(document.getElementById('contentArea')){
        $('#contentArea .ex-text').each(function() {
            $(this).find('a').each(function() {
                if(this.target == ''){
                    this.target = '_blank'
                }
            })
        });
    }
    if(document.getElementsByClassName('lazy')){
        var lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy"
        });
    }

    if(document.querySelector('.section')){
        let bgColor = document.querySelector('.section').style.backgroundColor;

        if(bgColor == 'rgb(5, 31, 46)'){
            document.body.classList.add('light-header');
        }else{
            document.body.classList.add('dark-header');
        }
    }else if(document.body.classList.contains('theme')){
        document.body.classList.add('light-header');
    }else{
        document.body.classList.add('dark-header');
    }

    if(document.querySelector('.profile-submenu__switch')){
        let clone = document.querySelector('.profile-submenu__item.current').cloneNode(true);

        $('.profile-submenu__switch').html(clone);

        $('.profile-submenu__switch').on('click', function() {
            let st = $(this).offset().top;
            let profileSubmenu = document.querySelector('.profile-submenu__list');
            if(profileSubmenu){
                if(profileSubmenu.style.display == 'none' || profileSubmenu.style.display == ''){
                    profileSubmenu.style.display = 'block';
                    $(profileSubmenu).css({
                        'top': st,
                        'height': 'calc(100vh - '+st + 'px)'
                    });
                    document.body.style.overflow = "hidden";
                }else{
                    profileSubmenu.style.display = 'none';
                }
            }
            document.querySelector('.navbar').classList.toggle('gray-bg');
        })
    }
});